import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const PRICE_POINTS = [
	{
		id: 'LOW',
		name: 'Low Range'
	},
	{
		id: 'MID',
		name: 'Mid Range'
	},
	{
		id: 'HIGH',
		name: 'High Range'
	}
];

const FabricType = ({ isDependentFilter }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	const onFetchData = async () => {
		let responseData = isDependentFilter ? dependentFilterList?.pricePointList : PRICE_POINTS;
		responseData = responseData?.map((item) => {
			return { id: item.constant, name: item.name };
		});
		setAllData(responseData);
		setData(responseData);
	};

	const handleSearch = (e) => {
		let searchResult = e.target.value
			? allData?.filter((item) => item?.name?.toLowerCase().includes(e.target.value.toLowerCase()))
			: allData;
		setData(searchResult);
	};
	return (
		<>
			<FilterName type="PRICE_RANGE" />
			<Checkbox data={data} type="PRICE_RANGE" handleSearch={handleSearch} />
		</>
	);
};

export default FabricType;
